import { page } from './Esearcher/page';
import company from './tab/company';
import company2 from './tab/company2';
import applicantListing from './search-list/applicant-action-lists';
import companyListing from './search-list/company-action-lists';
import jobListing from "./search-list/jobs";
import applicant from "./tab/cvApplicant";
import applicant2 from './tab/applicant';
import contactPerson from './tab/ansprechpartner';

page('company', company);
page('company', company2);
page('applicantListing', applicantListing);
page('companyListing', companyListing);
page('jobListing', jobListing);
page('applicant', applicant);
page('applicant', applicant2);
page('company', contactPerson);
page('project', contactPerson);
